export default "__VITE_ASSET__73c9f82b__"